export interface BBSUser {
  id: string;
  username: string;
  email: string;
  avatar: string;
  role: 'admin' | 'member';
  bio: string;
  joinDate: string;
  postCount: number;
}

export interface BBSPost {
  id: string;
  title: string;
  content: string;
  authorId: string;
  category: string;
  tags: string[];
  likes: number;
  views: number;
  replies: BBSReply[];
  attachments: BBSAttachment[];
  pinned: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface BBSReply {
  id: string;
  content: string;
  authorId: string;
  likes: number;
  createdAt: string;
}

export interface BBSAttachment {
  id: string;
  name: string;
  size: string;
  type: string;
  uploadedAt: string;
}

export const CATEGORIES = [
  { id: 'all', label: '全部帖子', icon: 'ri-layout-grid-line', color: '#7C3AED' },
  { id: 'rwa-discuss', label: 'RWA讨论', icon: 'ri-discuss-line', color: '#059669' },
  { id: 'policy', label: '政策解读', icon: 'ri-government-line', color: '#DC2626' },
  { id: 'tech', label: '技术分享', icon: 'ri-code-box-line', color: '#F59E0B' },
  { id: 'case', label: '案例分析', icon: 'ri-folder-chart-line', color: '#0891B2' },
  { id: 'market', label: '市场资讯', icon: 'ri-line-chart-line', color: '#7C3AED' },
  { id: 'files', label: '文件中心', icon: 'ri-file-upload-line', color: '#6B7280' },
];

export const MOCK_USERS: BBSUser[] = [
  {
    id: 'admin',
    username: 'RWA99管理员',
    email: '13810001256@126.com',
    avatar: 'R',
    role: 'admin',
    bio: 'RWA99.cn站长，专注香港RWA合规与代币化资产研究',
    joinDate: '2025-01-01',
    postCount: 38,
  },
  {
    id: 'user1',
    username: '张明远',
    email: 'zmyi@example.com',
    avatar: '张',
    role: 'member',
    bio: '合规律师，专注数字资产法律领域',
    joinDate: '2025-06-15',
    postCount: 12,
  },
  {
    id: 'user2',
    username: 'CryptoLily',
    email: 'lily@example.com',
    avatar: 'L',
    role: 'member',
    bio: '前HashKey合规总监，现独立顾问',
    joinDate: '2025-08-20',
    postCount: 24,
  },
  {
    id: 'user3',
    username: '陈伟鸿',
    email: 'cwh@example.com',
    avatar: '陈',
    role: 'member',
    bio: '区块链开发工程师，EVM生态研究者',
    joinDate: '2025-09-10',
    postCount: 8,
  },
];

export const MOCK_POSTS: BBSPost[] = [
  {
    id: 'post1',
    title: '【置顶】新手必读：RWA99论坛发言规范与合规红线',
    content: `欢迎来到RWA99论坛！本论坛定位为区块链与RWA领域的合规知识交流社区，请各位遵守以下规范：

**一、内容红线（以下内容将被删除）**
- 任何形式的投资建议、荐股荐币行为
- 涉及内地被明令禁止的虚拟货币交易、ICO等内容
- 违反中国内地及香港法律法规的内容
- 诽谤、骚扰、歧视性言论

**二、鼓励分享的内容**
- RWA政策解读与合规分析
- 代币化技术方案与案例研究
- 香港持牌机构动态
- 学术研究成果与白皮书解读

**三、文件上传规范**
- 支持格式：PDF、Word、PPT、Excel
- 单文件不超过50MB
- 禁止上传受版权保护的商业材料

祝大家交流愉快！`,
    authorId: 'admin',
    category: 'rwa-discuss',
    tags: ['置顶', '规范', '合规'],
    likes: 156,
    views: 3240,
    replies: [],
    attachments: [],
    pinned: true,
    createdAt: '2026-01-01 09:00',
    updatedAt: '2026-03-01 10:00',
  },
  {
    id: 'post2',
    title: '深度解析：香港SFC 2026年最新RWA监管框架要点（含逐条解读）',
    content: `SFC于2026年3月28日发布了最新代币化资产基金监管通函，本帖整理核心要点：

**一、资产准入标准收紧**
SFC明确了三类"可代币化资产"的底层资产门槛：
- 不动产：须完成香港土地注册处登记，估值报告须由持牌估价师出具
- 债券：须为投资级（BBB-以上），且在认可交易所挂牌
- 基金份额：须为SFC认可基金

**二、技术合规要求**
- 智能合约须经3家SFC认可机构审计
- 代币销毁/冻结机制为强制性要求
- 离线托管比例不低于95%

**三、投资者保护**
- 保留7天无理由赎回权
- 信息披露频率：日度更新NAV

欢迎大家交流！`,
    authorId: 'user2',
    category: 'policy',
    tags: ['SFC', '监管', 'RWA框架'],
    likes: 89,
    views: 1560,
    replies: [
      {
        id: 'r1',
        content: '感谢分享！请问不动产代币化中，境外物业是否适用相同标准？',
        authorId: 'user1',
        likes: 12,
        createdAt: '2026-03-28 15:30',
      },
      {
        id: 'r2',
        content: '境外物业需要额外提交"等效认可"申请，具体可以看SFC官网的FAQ Q.23',
        authorId: 'user2',
        likes: 8,
        createdAt: '2026-03-28 16:45',
      },
    ],
    attachments: [
      {
        id: 'att1',
        name: 'SFC_RWA_Circular_2026Q1_Summary.pdf',
        size: '1.2 MB',
        type: 'pdf',
        uploadedAt: '2026-03-28',
      },
    ],
    pinned: false,
    createdAt: '2026-03-28 14:00',
    updatedAt: '2026-03-28 16:45',
  },
  {
    id: 'post3',
    title: 'ERC-3643标准实战踩坑记录：合规代币开发全流程',
    content: `最近完成了一个香港RWA项目的智能合约开发，ERC-3643标准踩了不少坑，整理分享给大家。

**核心挑战：**
1. Identity Registry 部署成本比预期高40%
2. ClaimTopics的设计需要与合规团队深度配合
3. Transfer Restrictions Hook在多签钱包场景下有兼容性问题

**解决方案：**
- 使用Layer2降低Gas成本
- 提前与律师确认ClaimTopics映射KYC等级
- 针对多签做专项适配

附上开发文档，希望对大家有帮助。`,
    authorId: 'user3',
    category: 'tech',
    tags: ['ERC-3643', '智能合约', '开发'],
    likes: 67,
    views: 892,
    replies: [
      {
        id: 'r3',
        content: '请问Identity Registry用的是T-REX标准吗？有没有推荐的开源实现？',
        authorId: 'user1',
        likes: 5,
        createdAt: '2026-03-25 11:20',
      },
    ],
    attachments: [
      {
        id: 'att2',
        name: 'ERC3643_Implementation_Guide_v2.docx',
        size: '856 KB',
        type: 'doc',
        uploadedAt: '2026-03-24',
      },
      {
        id: 'att3',
        name: 'Transfer_Restrictions_Flow.xlsx',
        size: '234 KB',
        type: 'xlsx',
        uploadedAt: '2026-03-24',
      },
    ],
    pinned: false,
    createdAt: '2026-03-24 10:00',
    updatedAt: '2026-03-25 11:20',
  },
  {
    id: 'post4',
    title: 'BlackRock BUIDL vs Franklin Templeton BENJI：机构级代币化基金对比分析',
    content: `两只最具代表性的机构级代币化货币市场基金深度对比，供大家参考：

**BlackRock BUIDL**
- 底层资产：美国国债+逆回购协议
- AUM：120亿美元
- 区块链：Ethereum主网
- 最低认购：500万美元
- 赎回：T+0（工作日）

**Franklin Templeton BENJI**
- 底层资产：美国政府货币基金
- AUM：8.3亿美元  
- 区块链：Stellar+Polygon
- 最低认购：无限制
- 赎回：T+1

两者均已在香港二级市场获准交易，但门槛和流动性差异明显。

个人观点：BUIDL更适合机构配置，BENJI更具普惠性。`,
    authorId: 'user2',
    category: 'case',
    tags: ['BlackRock', 'BUIDL', '基金代币化'],
    likes: 134,
    views: 2180,
    replies: [
      {
        id: 'r4',
        content: '请问这两只基金内地投资者能买吗？',
        authorId: 'user3',
        likes: 3,
        createdAt: '2026-03-22 09:15',
      },
      {
        id: 'r5',
        content: '不能，内地投资者受《十部委通知》限制，不能购买境外发行的加密资产相关产品。',
        authorId: 'user1',
        likes: 15,
        createdAt: '2026-03-22 10:30',
      },
    ],
    attachments: [],
    pinned: false,
    createdAt: '2026-03-21 16:00',
    updatedAt: '2026-03-22 10:30',
  },
  {
    id: 'post5',
    title: '【资料分享】香港RWA监管沙盒申请全流程指引（2026版）',
    content: `整理了一份香港RWA监管沙盒申请的完整流程指引，包含申请材料清单、审核标准解析和常见拒绝原因分析。

主要内容：
- 申请资格评估（12项硬性条件）
- 材料准备指引（白皮书格式要求）
- 常见被拒原因TOP10
- 成功案例参考

PDF详见附件，欢迎交流！`,
    authorId: 'user1',
    category: 'files',
    tags: ['沙盒申请', 'SFC', '操作指引'],
    likes: 201,
    views: 3560,
    replies: [],
    attachments: [
      {
        id: 'att4',
        name: 'HK_RWA_Sandbox_Application_Guide_2026.pdf',
        size: '3.4 MB',
        type: 'pdf',
        uploadedAt: '2026-03-20',
      },
    ],
    pinned: false,
    createdAt: '2026-03-20 08:00',
    updatedAt: '2026-03-20 08:00',
  },
];
